const config = {
  tenant: 'txp-tenant',
  defaultLanguage: 'en-US',
  env: {
    name: 'dev',
  },
  storeDetails: {
    enabled: true,
  },
  coupons: {
    enabled: true,
  },
  analytics: {
    enabled: true,
    id: 'UA-137753698-1',
    gtmId: 'GTM-M2Q8XWD',
  },
};

export default config;
